import React from 'react';

import styles from './GeneralSettings.module.css';
import { Localization } from '@/components';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

export default function GeneralSettings() {
  const { t } = useTranslation();
  return (
    <div className='flex flex-col gap-y-10 w-full'>
      <h3 className='text-xl leading-7 font-bold text-center md:text-left dark:text-white'>
        {t('General Settings')}
      </h3>

      <div className='flex flex-col gap-y-8 w-full'>
        <div className='flex flex-col gap-y-2 w-full'>
          <h4 className={classNames(styles['section-title'], 'dark:text-white')}>
            {t('Language Settings')}
          </h4>
          <div className='flex justify-between items-center'>
            <div>
              <h5 className={classNames(styles['setting-title'], 'dark:text-white')}>
                {t('Language')}
              </h5>
              <p className={classNames(styles['setting-description'], 'dark:text-white/80')}>
                {t('You can choose a language you want')}
              </p>
            </div>

            <Localization short={false} />
          </div>
        </div>
        <div className='flex flex-col gap-y-2 w-full'>
          <h4 className={classNames(styles['section-title'], 'dark:text-white')}>
            {t('Visual Settings')}
          </h4>
          <div className='flex justify-between items-center'>
            <div>
              <h5 className={classNames(styles['setting-title'], 'dark:text-white')}>
                {t('Theme')}
              </h5>
              <p className={classNames(styles['setting-description'], 'dark:text-white/80')}>
                {t('You can set the theme here')}
              </p>
            </div>
            <select className='not-ready rounded-lg select-dark-mode'>
              <option>{t('Light')}</option>
              <option>{t('Dark')}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}
